import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { listEdges } from "../api/edgeApi";

// Target of the QR label (valonix.io/d/<serial> -> iot.valonix.io/device/<serial>): finds the edge with that label
// serial among the ones the signed-in user may see and opens its detail page.
export default function DeviceLookup() {
  const { t } = useTranslation();
  const { serial = "" } = useParams();
  const navigate = useNavigate();
  const accessToken = useSelector((s) => s.session.accessToken);
  const [state, setState] = useState("loading"); // loading | missing | error

  useEffect(() => {
    let live = true;
    (async () => {
      try {
        const wanted = serial.toUpperCase();
        const r = await listEdges(accessToken, { q: wanted, limit: 20 });
        const hit = r.items.find((e) => (e.valonix_serial || "").toUpperCase() === wanted) || r.items.find((e) => (e.name || "").toUpperCase() === wanted);
        if (!live) return;
        if (hit) navigate(`/edges/${hit.id}`, { replace: true });
        else setState("missing");
      } catch (e) {
        if (live) setState("error");
      }
    })();
    return () => {
      live = false;
    };
  }, [serial, accessToken, navigate]);

  return (
    <div style={{ padding: 24, color: "var(--text-primary)" }}>
      {state === "loading" && <p>{t("edges.deviceLookup.loading", { serial })}</p>}
      {state === "missing" && <p>{t("edges.deviceLookup.missing", { serial })}</p>}
      {state === "error" && <p>{t("edges.deviceLookup.error")}</p>}
      {state !== "loading" && <Link to="/edges">{t("edges.deviceLookup.back")}</Link>}
    </div>
  );
}
